import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import SkinCareIntro from 'on_web/components/pceonboarding/skincare/SkinCareIntro';
import SkinCareStep1 from 'on_web/components/pceonboarding/skincare/SkinCareStep1';
import SkinCareStep2 from 'on_web/components/pceonboarding/skincare/SkinCareStep2';
import SkinCareStep3 from 'on_web/components/pceonboarding/skincare/SkinCareStep3';
import SkinCareStep4 from 'on_web/components/pceonboarding/skincare/SkinCareStep4';
import SkinCareStep5 from 'on_web/components/pceonboarding/skincare/SkinCareStep5';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import {
  ROUTE_PCE_ONBOARDING_GENERAL,
  ROUTE_RETAIL_EXPERIENCE_CART,
} from 'routes';

import UserProfileContext from 'on_web/context/userProfileContext';
import useUsersApi from '../hooks/useUsersApi';

export default function PceOnboardingSkinCarePage(props) {
  const [
    { response, loading, getUserData, saveUserData, errorSaving },
  ] = useUsersApi();
  const [visibleStep, setVisibleStep] = useState(0);

  useEffect(() => {
    getUserData().then(userData => {
      if (userData !== null) {
        if (userData.user_metadata.pceFacialConcerns === undefined) {
          setVisibleStep(0);
        } else if (userData.user_metadata.pceEyeAreaConcerns === undefined) {
          setVisibleStep(2);
        } else if (userData.user_metadata.pceSkinFeel === undefined) {
          setVisibleStep(3);
        } else if (
          userData.user_metadata.pceSkinHairAllergies === undefined &&
          userData.user_metadata.pceAirPollution === undefined
        ) {
          setVisibleStep(4);
        } else if (
          userData.user_metadata.pceSensitiveOrIrritatedSkin === undefined &&
          userData.user_metadata.pceLikeScentedProducts === undefined
        ) {
          setVisibleStep(5);
        } else {
          setVisibleStep(0);
        }
      }
    });
  }, [getUserData]);

  const onWelcome = () => {
    // when intro is displayed, it is time for another step
    setVisibleStep(visibleStep + 1);
  };

  const handleNextClick = userMetaData => {
    if (userMetaData) {
      response.user_metadata = userMetaData;
      saveUserData(response);
    }

    if (visibleStep < 5) {
      setVisibleStep(visibleStep + 1);
    } else {
      response.user_metadata.onboarding = {
        ...response.user_metadata.onboarding,
        onboardingPceFinished: true,
        pceSkinCareFinished: true,
      };
      saveUserData(response).then(() => {
        if (errorSaving == null) {
          props.history.push(ROUTE_RETAIL_EXPERIENCE_CART);
        }
      });
    }
  };

  return (
    <Grid
      container={useMediaQuery('(min-width:1000px)')}
      direction="row"
      justify="center"
      alignItems="center"
    >
      {loading === false && response && visibleStep != null && (
        <UserProfileContext.Provider
          value={{
            userMetaData: response.user_metadata,
          }}
        >
          {visibleStep === 0 && (
            <PageItemContainer>
              <SkinCareIntro onWelcome={onWelcome} />
            </PageItemContainer>
          )}
          {visibleStep === 1 && (
            <PageItemContainer>
              <SkinCareStep1
                onClickBack={() =>
                  props.history.push({
                    pathname: ROUTE_PCE_ONBOARDING_GENERAL,
                    state: {
                      startFromLast: true,
                    },
                  })
                }
                onClickNext={userMetaData => handleNextClick(userMetaData)}
              />
            </PageItemContainer>
          )}
          {visibleStep === 2 && (
            <PageItemContainer>
              <SkinCareStep2
                onClickBack={() => setVisibleStep(visibleStep - 1)}
                onClickNext={userMetaData => handleNextClick(userMetaData)}
              />
            </PageItemContainer>
          )}
          {visibleStep === 3 && (
            <PageItemContainer>
              <SkinCareStep3
                onClickBack={() => setVisibleStep(visibleStep - 1)}
                onClickNext={userMetaData => handleNextClick(userMetaData)}
              />
            </PageItemContainer>
          )}
          {visibleStep === 4 && (
            <PageItemContainer>
              <SkinCareStep4
                onClickBack={() => setVisibleStep(visibleStep - 1)}
                onClickNext={userMetaData => handleNextClick(userMetaData)}
              />
            </PageItemContainer>
          )}
          {visibleStep === 5 && (
            <PageItemContainer>
              <SkinCareStep5
                onClickBack={() => setVisibleStep(visibleStep - 1)}
                onClickNext={userMetaData => handleNextClick(userMetaData)}
              />
            </PageItemContainer>
          )}
        </UserProfileContext.Provider>
      )}
    </Grid>
  );
}
